/** Dialog sizes for the preset list and the add-or-edit form. */
export const presetModalTokens = {
  list: {
    width: '90vw',
    maxWidth: '40rem',
  },
  addOrEdit: {
    width: '70vw',
    maxWidth: '30rem',
    minHeight: '35rem',
  },
} as const;
